module.exports = __webpack_public_path__ + "static/media/waving_small.5a7fe0b1.svg";